import React from "react";
import { Loader } from "components/commons";
import styles from "./shift-records-details-cash-and-non-cash.module.scss";
import ShiftDetailsNonSales from "./shift-details-cash-non-cash-non-sales";
import ShiftDetailsCash from "./shift-details-cash-non-cash-cash";
import ShiftDetailsExpense from "./shift-details-cash-non-cash-expense";
import ShiftDetailsCashOnHand from "./shift-details-cash-non-cash-cash-on-hand";
import ShiftDetailsNetCashSummary from "./shift-details-cash-non-cash-net-cash";
import ShiftDetailsBankDeposit from "./shift-details-cash-non-cash-bank-deposit";
import ShiftDetailsKeyAccount from "./shift-details-cash-non-cash-key-account";
import ShiftDetailsPromoSummary from "./shift-details-cash-non-cash-promo-summary";
import ShiftDetailsNonCashSummary from "./shift-details-non-cash-summary/shift-details-non-cash-summary";

const ShiftRecordsDetailsCashAndNonCashModule = (props) => {
  const {
    loadingShift,
    shift,
    safeDrop,
    setSafeDrop,
    employees,
    setEmployees,
    pageMode,
    employeesToPay,
    setEmployeesToPay,
    variance,
    setVariance,
    refetchShift,
    beginningBalance,
    setBeginningBalance,
    updatePaymentMethodRefNumber,
    updateTransactionPaymentMethod,
    updateTransactionAccountability,
  } = props;

  return (
    <>
      <Loader open={loadingShift} />
      {shift && !loadingShift && (
        <div className={styles.container}>
          <ShiftDetailsNonSales shift={shift} />
          <ShiftDetailsNonCashSummary
            shift={shift}
            refetchShift={refetchShift}
            pageMode={pageMode}
            updatePaymentMethodRefNumber={updatePaymentMethodRefNumber}
            updateTransactionPaymentMethod={updateTransactionPaymentMethod}
            updateTransactionAccountability={updateTransactionAccountability}
            employees={employees}
          />
          {/* <ShiftDetailsNonCash shift={shift} /> */}
          <ShiftDetailsCash
            shift={shift}
            pageMode={pageMode}
            updateTransactionPaymentMethod={updateTransactionPaymentMethod}
          />
          <ShiftDetailsPromoSummary shift={shift} />
          <ShiftDetailsExpense shift={shift} />
          <ShiftDetailsCashOnHand
            shift={shift}
            safeDrop={safeDrop}
            setSafeDrop={setSafeDrop}
            pageMode={pageMode}
          />
          <ShiftDetailsNetCashSummary
            shift={shift}
            pageMode={pageMode}
            employees={employees}
            setEmployees={setEmployees}
            safeDrop={safeDrop}
            employeesToPay={employeesToPay}
            setEmployeesToPay={setEmployeesToPay}
            variance={variance}
            setVariance={setVariance}
            beginningBalance={beginningBalance}
            setBeginningBalance={setBeginningBalance}
          />
          <ShiftDetailsBankDeposit shift={shift} />
          <ShiftDetailsKeyAccount shift={shift} />
        </div>
      )}
    </>
  );
};

export default ShiftRecordsDetailsCashAndNonCashModule;
